import React, { useEffect } from "react";
import { Link, Redirect, Route, Switch, useLocation } from "react-router-dom";
import "./styles/tokens.css";
import "./styles/app.css";
import "./styles/leads.css";
import "./styles/reports.css";
import { isLoggedIn, getToken } from "./lib/auth";
import { setAuthorization } from "../helpers/api_helper";
import { ShellProvider } from "./shell/context";
import AppShell from "./shell/AppShell";
import Login from "./pages/Login";
import Today from "./pages/Today";
import DailyNotes from "./pages/DailyNotes";
import People from "./pages/People";
import Companies from "./pages/Companies";
import ContactDetail from "./pages/ContactDetail";
import CompanyDetail from "./pages/CompanyDetail";
import Imports from "./pages/Imports";
import Settings from "./pages/Settings";
import Leads from "./pages/Leads";
import LeadDetail from "./pages/LeadDetail";
import Signals from "./pages/Signals";
import WeeklyBrief from "./pages/WeeklyBrief";
import Funnel from "./pages/Funnel";
import Search from "./pages/Search";
import { Empty, PageHead } from "./ui";

// v1.1 pages kept as they are (no new features), restyled by the tokens.
import Jobs from "../pages/Jobs/Index";
import HiringCompanies from "../pages/Companies/Index";
import ContentArticles from "../pages/Content/Articles";
import ContentSocialPosts from "../pages/Content/SocialPosts";

const legacy = (Component) =>
    function Legacy(props) {
        return (
            <div className="hz-legacy">
                <Component {...props} />
            </div>
        );
    };

const LegacyJobs = legacy(Jobs);
const LegacyHiring = legacy(HiringCompanies);
const LegacyArticles = legacy(ContentArticles);
const LegacySocial = legacy(ContentSocialPosts);

function NotFound() {
    return (
        <>
            <PageHead title="Not found" />
            <div className="hz-card">
                <Empty>
                    This page does not exist. <Link to="/today">Go to Today</Link>.
                </Empty>
            </div>
        </>
    );
}

function Protected({ children }) {
    const location = useLocation();
    if (!isLoggedIn()) return <Redirect to={{ pathname: "/login", state: { from: location } }} />;
    return children;
}

export default function HorusApp() {
    useEffect(() => {
        document.body.classList.add("hz-body");
        const t = getToken();
        if (t) setAuthorization(t); // legacy APIClient
    }, []);

    return (
        <Switch>
            <Route path="/login" component={Login} />
            <Redirect from="/giris" to="/login" />
            <Route>
                <Protected>
                    <ShellProvider>
                        <AppShell>
                            <Switch>
                                <Redirect exact from="/" to="/today" />
                                <Redirect from="/dashboard" to="/today" />
                                <Route path="/today" component={Today} />
                                <Route path="/notes/:date?" component={DailyNotes} />
                                <Route path="/crm/contacts/:id" component={ContactDetail} />
                                <Route path="/crm/contacts" component={People} />
                                <Redirect from="/crm/people/:id" to="/crm/contacts/:id" />
                                <Redirect from="/crm/people" to="/crm/contacts" />
                                <Route path="/crm/companies/:id" component={CompanyDetail} />
                                <Route path="/crm/companies" component={Companies} />
                                <Route path="/crm/leads/:id" component={LeadDetail} />
                                <Route path="/crm/leads" component={Leads} />
                                <Redirect from="/leads" to="/crm/leads" />
                                <Route path="/crm/signals" component={Signals} />
                                <Redirect from="/signals" to="/crm/signals" />
                                <Route path="/crm/imports/:tab?" component={Imports} />
                                <Route path="/reports/weekly-brief" component={WeeklyBrief} />
                                <Route path="/reports/funnel" component={Funnel} />
                                <Redirect exact from="/reports" to="/reports/weekly-brief" />
                                <Route path="/search" component={Search} />
                                <Route path="/settings/:tab?" component={Settings} />
                                <Route path="/content/articles" component={LegacyArticles} />
                                <Route path="/content/social" component={LegacySocial} />
                                <Route path="/talent/jobs" component={LegacyJobs} />
                                <Route path="/talent/companies" component={LegacyHiring} />
                                <Route path="/jobs" render={({ location }) => <Redirect to={{ pathname: "/talent/jobs", search: location.search }} />} />
                                <Redirect from="/companies" to="/talent/companies" />
                                <Route component={NotFound} />
                            </Switch>
                        </AppShell>
                    </ShellProvider>
                </Protected>
            </Route>
        </Switch>
    );
}
